import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/error.jpg")